import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { InfoBarComponent } from '@libs/common/components';
import { InfoBarContentItemModel, InfoBarContentModel } from '@libs/cms/models';
import { provideContentTrackingContext } from '@libs/shared/tracking';
import { ContentBaseComponent } from '../content-base.component';
import { InfobarState } from './infobar-state.store';

@Component({
  selector: 'ui-info-bar-content',
  templateUrl: './info-bar-content.component.html',
  styleUrls: ['./info-bar-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InfoBarComponent,
  ],
  host: {
    '[hidden]': 'isComponentHidden()',
  },
  providers: [provideContentTrackingContext(InfoBarContentComponent)],
})
export class InfoBarContentComponent extends ContentBaseComponent<InfoBarContentModel> {
  public readonly infobarState: InfobarState = inject(InfobarState);

  public readonly visibleInfobars: Signal<InfoBarContentItemModel[] | undefined> = computed(() => {
    return this.data().infobars.filter(
      item => !this.infobarState.isHidden(item.uuid),
    );
  });

  public readonly isComponentHidden: Signal<boolean> = computed(() => {
    return !this.visibleInfobars()?.length;
  });

  public onInfobarClosed(uuid: string): void {
    if (uuid) {
      this.infobarState.markClosed(uuid);
    }
  }
}
